<template>
  <div class="container d-container">
    <template v-if="!info.isPast && !info.hasDone && qa.length">
      <div class="preface text-center">
        <div class="prefaceTitle">
          <div class="bg-white inline-block" style="padding: 0 8%;">开门去玩活动反馈表</div>
        </div>
        用心聆听，你的评价就是我们进步的最大动力，
        <br>期待你真实的声音！
        <div class="tips">*稻稻会在本月所有的反馈中随机抽取5位幸运的小伙伴儿，将送上稻草人限定周边。</div>
      </div>

      <div class="flex">
        <img src="../assets/image/daoFund/iconOneBig.png" style="width: 50px;height:50px;margin-right: 10px;"/>
        <div class="dao-red">
          稻稻承诺每收到一份反馈，将积累{{info.daoFund.dao_donation_num + info.daoFund.user_donation_num}}元公益基金，当累积金额超过{{daoFund.batch_num}}元时，由“稻·基金”项目组把款项投入到符合捐助条件的项目中，我们一起为旅行生态圈，为当地的人和当地环境贡献一份旅行者的力量！
        </div>
      </div>

      <div class="cardBox" style="margin-bottom: 3em;">
        <div class="boxHeading">基本信息</div>
        <div class="boxTitle">路线名称</div>{{info.abbreviation}}
        <br><div class="boxTitle">出队日期</div>{{info.start}}
      </div>

      <form @submit.prevent="submit()">
        <div class="form-group" v-for="item in qa" track-by="$index">
          <label class="control-label">{{$index + 1}} . {{item.question | questionFilter info.leaderRole}}</label>
          <div>
            <template v-if="item.type === 1">
              <label class="radio-inline" v-for="option in item.options">
                <template v-if="option.text !== '其他'">
                  <input type="radio" name="q{{$parent.$index}}" v-model="item.answer" :value="option" required>{{option.text}}
                </template>
                <template v-if="option.text === '其他'">
                  <input type="radio" name="q{{$parent.$index}}" v-model="item.answer" :value.sync="{text: '[其他]' + item.other.text, code: null}" required>其他<input v-model="item.other.text" type="text" class="d-form-control">
                </template>
              </label>
            </template>

            <template v-if="item.type === 2">
              <label class="checkbox-inline" v-for="option in item.options">
                <template v-if="option.text !== '其他'">
                  <input  type="checkbox" name="q{{$index}}" v-model="item.answer" :value="option" required>{{option}}
                </template>
                <template v-if="option.text === '其他'">
                  <input type="checkbox" name="q{{$parent.$index}}" v-model="item.answer" :value.sync="{text: '[其他]' + item.other.text, code: null}" required>其他<input v-model="item.other.text" type="text" class="d-form-control">
                </template>
              </label>
            </template>

            <textarea v-if="item.type === 3" v-model="item.answer.text" name="q{{$index}}" id="q3" cols="30" rows="3" class="form-control" required></textarea>

            <template v-if="item.type === 4">
              <label class="radio-inline" v-for="option in item.options">
                <template v-if="option.text !== '其他'">
                  <input type="radio" name="q{{$parent.$index}}" v-model="item.answer" :value="option" required>{{option.text}}
                </template>
                <template v-if="option.text === '其他'">
                  <input type="radio" name="q{{$parent.$index}}" v-model="item.answer" :value.sync="{text: '[其他]' + item.other.text, code: null}" required>其他<input v-model="item.other.text" type="text" class="d-form-control">
                </template>
              </label>
              <br><input v-model="item.other.why" type="text" class="d-form-control" style="min-width: 250px;" placeholder="和稻稻说些什么吧（选填）" v-if="item.answer.text === '1分' || item.answer.text === '2分' || item.answer.text === '3分'">
            </template>

            <textarea v-if="item.type === 5" v-model="item.answer.text" name="q{{$index}}" id="q3" cols="30" rows="3" class="form-control"></textarea>
          </div>
        </div>
        <div class="text-center">
          <button class="btn btn-primary" type="submit">提交</button>
        </div>
      </form>
    </template>

    <div v-if="info.isPast" class="alert alert-danger">
      该反馈已过期……
    </div>

    <div v-if="info.hasDone">
      <h1 class="text-center brand-red font-bold">反馈成功</h1>
      <div class="cardBox">
        <div class="boxHeading">感谢你为稻·基金项目献出爱心</div>
        <div class="text-center flex font-bold">
          <div class="flex-item">
            <img src="../assets/image/daoFund/userDonation.png" class="fundIcon">
            <div>本次捐出</div>
            <div class="dao-red">{{daoFund.fundUserDonationNum}}颗爱心</div>
          </div>
          <div class="flex-item">
            <img src="../assets/image/daoFund/daoDonation.png" class="fundIcon">
            <div>稻草人配捐</div>
            <div class="dao-red">{{daoFund.fundDaoDonationNum}}颗爱心</div>
          </div>
          <div class="flex-item">
            <img src="../assets/image/daoFund/allDonation.png" class="fundIcon">
            <div>总价值</div>
            <div class="dao-red">{{daoFund.fundAllDonationNum}}元</div>
          </div>
        </div>

        <div class="daoFundProgress">
          <div class="flex">
            <div class="flex-item">项目捐助款积累进度</div>
            <div class="flex-item text-right">{{daoFund.daoFundProgress}}/{{daoFund.daoFundMaxDonationNum}}</div>
          </div>
          <div class="daoFundProgressBg">
            <div class="daoFundProgressContent" :style="'width:' + daoFund.daoFundProgressPercent + '%;'"></div>
          </div>

          <p class="tips">*捐助完成后我们会第一时间以邮件形式发送给大家进展</p>
        </div>
      </div>

      <div class="cardBox present">
        <div class="img relative">
          <img src="../assets/image/daoFund/project.png" class="img-block">
          <span class="titleTag">公益活动</span>
        </div>

        <div class="word text-right">
          <h1 class="dao-red text-left">稻 · 基金</h1>
          <p class="text-left">
            作为一家由旅行者创立的旅行公司，
            <br>我们持续得从当地收获。收获照片、经历、故事和能量，依靠这些收获我们获得成长。
            <br>如今能将这份能量回馈给目的地，使得这些地区更好的发展，赋予正面的影响，这个过程也使得我们自己获得更好的动力。
          </p>

          <a :href="daoFundUrl">
            <div class="button">点击了解详情</div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import config from '../libs/config'
  let qas = {
    qa1: [
      {
        question: '你是如何得知此次活动?',
        ques: '如何得知?',
        answer: {},
        type: 1,
        options: [
          {
            text: '稻草人官网',
            code: null
          },
          {
            text: '微博',
            code: null
          },
          {
            text: '微信',
            code: null
          },
          {
            text: '豆瓣',
            code: null
          },
          {
            text: '朋友推荐',
            code: null
          },
          {
            text: '其他',
            code: null
          }
        ],
        other: ''
      },
      {
        question: '你对这次活动整体满意度打几分（满分5分）?',
        ques: '活动满意度',
        answer: {},
        type: 1,
        options: [
          {
            text: '5分',
            code: 5
          },
          {
            text: '4分',
            code: 4
          },
          {
            text: '3分',
            code: 3
          },
          {
            text: '2分',
            code: 2
          },
          {
            text: '1分',
            code: 1
          }
        ],
        other: ''
      },
      {
        question: '你认为本次活动有什么可以改进的地方吗（环节安排、时间控制、老师、领队等）？',
        ques: '建议',
        answer: {},
        type: 3,
        options: [],
        other: ''
      },
      {
        question: '你会把稻草人推荐给你的朋友吗？',
        ques: '推荐给朋友',
        answer: {},
        type: 1,
        options: [
          {
            text: '必须嗒!',
            code: 3
          },
          {
            text: '考虑考虑',
            code: 2
          },
          {
            text: '坚决不会，哼',
            code: 1
          }
        ],
        other: ''
      }
    ],
    qa2: [
      {
        question: 'Hello,请问你现在扎根儿哪里？（请在下方选择常驻地）',
        ques: '常驻地',
        answer: {},
        type: 1,
        options: [
          {
            text: '上海',
            code: null
          },
          {
            text: '北京',
            code: null
          },
          {
            text: '苏州',
            code: null
          },
          {
            text: '杭州',
            code: null
          },
          {
            text: '南京',
            code: null
          },
          {
            text: '其他',
            code: null
          }
        ],
        other: ''
      },
      {
        question: '这是你第一次参加稻草人的活动吗？',
        ques: '是否第一次参加稻草人？',
        answer: {},
        type: 1,
        options: [
          {
            text: '是',
            code: 1
          },
          {
            text: '否',
            code: 0
          }
        ],
        other: ''
      },
      {
        question: '你是如何得知此次活动?',
        ques: '如何得知?',
        answer: {},
        type: 1,
        options: [
          {
            text: '稻草人官网',
            code: null
          },
          {
            text: '微博',
            code: null
          },
          {
            text: '微信',
            code: null
          },
          {
            text: '豆瓣',
            code: null
          },
          {
            text: '朋友推荐',
            code: null
          },
          {
            text: '其他',
            code: null
          }
        ],
        other: ''
      },
      {
        question: '你对本次活动的整体评价是？',
        ques: '活动整体评价？',
        answer: {},
        type: 1,
        options: [
          {
            text: '非常满意，太棒了',
            code: 5
          },
          {
            text: '满意，期待下次活动',
            code: 4
          },
          {
            text: '还不错，但没那么好',
            code: 3
          },
          {
            text: '一般般，但不算很差',
            code: 2
          },
          {
            text: '太差劲了，下次不来了',
            code: 1
          }
        ],
        other: ''
      },
      {
        question: '你对本条路线的评价是？',
        ques: '路线评价？',
        answer: {},
        type: 1,
        options: [
          {
            text: '非常喜欢，好赞',
            code: 5
          },
          {
            text: '喜欢，有特色',
            code: 4
          },
          {
            text: '还行吧',
            code: 3
          },
          {
            text: '不太喜欢',
            code: 2
          },
          {
            text: '很不喜欢',
            code: 1
          }
        ],
        other: ''
      },
      {
        question: '你对本次领队的评价是？',
        ques: '领队评价？',
        answer: {},
        type: 1,
        options: [
          {
            text: '非常满意，期待下次还能跟TA的队',
            code: 5
          },
          {
            text: '满意，尽职尽责',
            code: 4
          },
          {
            text: '一般，还行吧',
            code: 3
          },
          {
            text: '不太满意',
            code: 2
          },
          {
            text: '不想再见到TA',
            code: 1
          }
        ],
        other: ''
      },
      {
        question: '你以后还会参加稻草人CityWalks吗？',
        ques: '是否还会参加CW？',
        answer: {},
        type: 1,
        options: [
          {
            text: '是',
            code: 1
          },
          {
            text: '否',
            code: 0
          }
        ],
        other: ''
      },
      {
        question: '你会将稻草人CityWalks推荐给你的亲友吗？',
        ques: '是否将CW推荐给亲友？',
        answer: {},
        type: 1,
        options: [
          {
            text: '是',
            code: 1
          },
          {
            text: '否',
            code: 0
          }
        ],
        other: ''
      },
      {
        question: '有什么想说的（比如：稻草人哪些做的好的，做的不好的，改进的点，对领队想说的话等等）',
        ques: '建议',
        answer: {},
        type: 3,
        options: [],
        other: ''
      }
    ],
    qa3: [
      {
        question: '本次活动，老师为你带来的体验如何？（如老师的讲解、演示、教学等）',
        ques: '老师服务',
        answer: {},
        type: 4,
        options: [
          {
            text: '5分',
            code: 5
          },
          {
            text: '4分',
            code: 4
          },
          {
            text: '3分',
            code: 3
          },
          {
            text: '2分',
            code: 2
          },
          {
            text: '1分',
            code: 1
          }
        ],
        other: ''
      },
      {
        question: '活动中老师对大家的关注度如何？（如是否为大家解疑、是否与大家互动等）',
        ques: '老师关注度',
        answer: {},
        type: 4,
        options: [
          {
            text: '5分',
            code: 5
          },
          {
            text: '4分',
            code: 4
          },
          {
            text: '3分',
            code: 3
          },
          {
            text: '2分',
            code: 2
          },
          {
            text: '1分',
            code: 1
          }
        ],
        other: ''
      },
      {
        question: '领队的主动服务意识如何？（如是否关注你的需求、是否与老师协作等）',
        ques: '领队服务',
        answer: {},
        type: 4,
        options: [
          {
            text: '5分',
            code: 5
          },
          {
            text: '4分',
            code: 4
          },
          {
            text: '3分',
            code: 3
          },
          {
            text: '2分',
            code: 2
          },
          {
            text: '1分',
            code: 1
          }
        ],
        other: ''
      },
      {
        question: '领队对整个活动的把控如何？（如是否按时开始、是否组织活动顺利进行等）',
        ques: '领队控场',
        answer: {},
        type: 4,
        options: [
          {
            text: '5分',
            code: 5
          },
          {
            text: '4分',
            code: 4
          },
          {
            text: '3分',
            code: 3
          },
          {
            text: '2分',
            code: 2
          },
          {
            text: '1分',
            code: 1
          }
        ],
        other: ''
      },
      {
        question: '领队是否有帮大家拍照呀？',
        ques: '领队拍照',
        answer: {},
        type: 4,
        options: [
          {
            text: '有哦，拍的很好',
            code: 4
          },
          {
            text: '有的，技术待提高',
            code: 3
          },
          {
            text: '没有,但是引导大家分享照片',
            code: 2
          },
          {
            text: '唉, 完全没有',
            code: 1
          }
        ],
        other: ''
      },
      {
        question: '你还会继续参加稻草人sidetour吗？',
        ques: '是否还会参加ST',
        answer: {},
        type: 4,
        options: [
          {
            text: '必须哒',
            code: 3
          },
          {
            text: '考虑考虑',
            code: 2
          },
          {
            text: '坚决不会，哼',
            code: 1
          }
        ],
        other: ''
      },
      {
        question: '你是如何得知此次活动？',
        ques: '如何得知',
        answer: {},
        type: 4,
        options: [
          {
            text: '稻草人官网',
            code: null
          },
          {
            text: '微信',
            code: null
          },
          {
            text: '朋友推荐',
            code: null
          },
          {
            text: '其他',
            code: null
          }
        ],
        other: ''
      },
      {
        question: '你会把稻草人sidetour推荐给朋友吗？',
        ques: '是否推荐',
        answer: {},
        type: 4,
        options: [
          {
            text: '必须哒',
            code: 3
          },
          {
            text: '考虑考虑',
            code: 2
          },
          {
            text: '坚决不会，哼',
            code: 1
          }
        ],
        other: ''
      },
      {
        question: '你还有什么想要告诉我们的吗？（关于活动感受和意见、关于领队，或者期待什么活动等等）',
        ques: '建议',
        answer: {},
        type: 5,
        options: [],
        other: ''
      }
    ]
  }
  export default {
    data () {
      return {
        qa: [],
        info: {
          hasDone: true
        },
        daoFund: {},
        daoFundUrl: process.env.TOUR_URL + '/foundation/'
      }
    },
    filters: {
      questionFilter (question, leaderRole) {
        if (leaderRole === 'VOLUNTEER') {
          return question.replace('领队', '志愿者').replace('稻草人sidetour', '稻草人城市玩家活动').replace('稻草人CityWalks', '稻草人城市玩家活动')
        } else {
          return question
        }
      }
    },
    methods: {
      getInfo () {
        let orderId = this.$route.query.orderId
        return this.$http.get(`${config.apiWe}/product/feedback/${orderId}/info`)
          .then(({data}) => {
            this.info = data
            if (data.hasDone) {
              this.getDaoFund()
            }
            this.getQa(data.catalog, data.start)
          })
      },
      getQa (catalog, start) {
        var date = '2018-10-13'
        if (new Date(start).getTime() > new Date(date).getTime()) {
          let m = {
            'TT': 'qa1',
            'ST': 'qa3',
            'CE': 'qa1',
            'CW': 'qa2'
          }
          this.qa = qas[m[catalog]] || []
        } else {
          let n = {
            'TT': 'qa1',
            'ST': 'qa1',
            'CE': 'qa1',
            'CW': 'qa2'
          }
          this.qa = qas[n[catalog]] || []
        }
      },
      submit () {
        let orderId = this.$route.query.orderId
        if (this.qa.some(item => !item.answer)) {
          window.alert('请检查表单')
          return
        }
        let answers = this.qa.map(item => {
          return {
            question: item.question,
            answer: item.answer.text,
            code: item.answer.code === undefined ? null : item.answer.code,
            ques: item.ques,
            type: item.type,
            why: item.other.why
          }
        })
        if (answers.some(({ answer }) => {
          return answer === null || answer === undefined
        })) {
          window.alert('请检查表单')
          return Promise.reject()
        }
        return this.$http.post(`${config.apiWe}/product/feedback`, {
          orderId,
          answers
        })
        .then(() => {
          window.alert('提交成功!')
          this.getDaoFund()
          this.info.hasDone = true
        }, ({data}) => {
          window.alert(data)
        })
      },
      getDaoFund () {
        return this.$http.get(`${config.apiWe}/product/feedback/${this.$route.query.orderId}/dao-fund`)
          .then(({data}) => {
            this.daoFund = data
          })
      }
    },
    route: {
      data () {
        this.getQa()
        return this.getInfo()
      }
    }
  }
</script>

<style scoped>
  .d-form-control {
    border: none;
    border-bottom: 1px solid #ddd;
    line-height: 1;
  }
  .d-form-control:focus {
    outline: none;
  }
  .container {
    width: 100%;
  }
  .d-container {
    margin-top: 30px;
    margin-bottom: 70px;
  }
  .preface {
    border-top: 1px dashed #E60012;
    padding: 2em 0;
    margin-top: 3em;
    position: relative;
  }
  .prefaceTitle {
    position: absolute;
    width: 100%;
    top: -1em;
    color: #E60012;
    font-size: 2em;
    font-weight: bold;
  }
  .cardBox {
    padding: 20px;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    margin-top: 2em;
  }
  .boxHeading {
    border-left: 4px solid #E60012;
    padding: 0 5px;
    font-weight: bold;
    margin-bottom: 2em;
    line-height: 1;
  }
  .boxTitle {
    display: inline-block;
    width: 80px;
    color: #606266;
    line-height: 40px;
    padding: 0 12px 0 0;
  }
  .fundIcon {
    width: 5em;
  }
  .daoFundProgress {
    margin-top: 3em;
  }
  .daoFundProgressBg {
    border-radius: 100px;
    background: #ebeef5;
    overflow: hidden;
    position: relative;
    height: 20px;
  }
  .daoFundProgressContent {
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 100px;
    background: #E60012;
    height: 20px;
    width: 0;
  }
  .tips {
    color: #909399;
    font-size: 13px;
    margin-top: 10px;
  }
  .present .titleTag {
    background: #E60012;
    color: #FFF;
    padding: 3px 10px;
    position: absolute;
    top: 0;
    left: 0;
    border-bottom-right-radius: 8px;
  }
  .present .word {
    padding: 20px;
  }
  .present .button {
    display: inline-block;
    background: #E60012;
    padding: 5px 10px;
    color: #FFF;
    font-weight: bold;
    border-radius: 10px;
    margin-top: 2em;
  }
  @media (min-width: 1000px) {
    .present .img {
      vertical-align: top;
      display: inline-block;
      width: 50%;
    }
    .present .word {
      vertical-align: top;
      display: inline-block;
      width: 47%;
      padding: 20px 1.2%;
    }
  }
</style>



/** WEBPACK FOOTER **
 ** Feedback.vue?7aec50ae
 **/